import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import { DashboardContext } from '../../store/DashboardStore';
import Panel from './Panel';

const Dashboard: React.FC = () => {
  const dashboard = useContext(DashboardContext);
  const { panelList } = dashboard;

  const renderRows = () => {
    const numberArray: number[] = [0, 1, 2];
    return numberArray.map((row: number) => (
      <Grid container>
        {panelList
          .filter((panel) => panel.row === row)
          .map((panel) => (
            <Grid item xs={panel.width as any}>
              <Panel
                panelName={panel.panelName}
                panelType={panel.panelType}
                endpoint={panel.endpoint}
                textColor={panel.textColor}
                backColor={panel.backColor}
              />
            </Grid>
          ))}
      </Grid>
    ));
  };

  return <div>{renderRows()}</div>;
};

export default Dashboard;
